<template>
	<div class="cassie-vertical-md mb-2">
		<v-row
			v-if="loaded"
			class="flex flex-row"
		>
			<v-col
				cols="3"
				class="d-flex flex-grow-1"
			>
				<DoughnutChartCard
					v-if="chartDatas.length > 0"
					:chart-data="chartDatas[0]"
					:chart-options="chartOptions"
					:plugins="plugins"
					container-id="cookies"
					title="Cookies"
					class="flex-grow-1"
				/>
			</v-col>
			<v-col cols="3">
				<SiteScannerColumn
					:summary="scanReport"
				/>
			</v-col>
			<v-col
				cols="3"
				class="d-flex flex-grow-1"
			>
				<DoughnutChartCard
					v-if="chartDatas.length > 0"
					:chart-data="chartDatas[1]"
					:chart-options="chartOptions"
					:plugins="plugins"
					container-id="cookies-two"
					title="Trackers"
					class="flex-grow-1"
				/>
			</v-col>
			<v-col
				cols="3"
				class="d-flex flex-grow-1"
			>
				<DoughnutChartCard
					v-if="chartDatas.length > 0"
					:chart-data="chartDatas[2]"
					:chart-options="chartOptions"
					:plugins="plugins"
					container-id="cookies-three"
					title="Resources"
					class="flex-grow-1"
				/>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import DoughnutChartCard from '../../../../../../../shared/components/doughnut-chart-card.vue'
import {
	getScanSummary,
	getScanChart
} from '../../../../../../../shared/utils/api/site-scanner.js'
import SiteScannerColumn from './site-scanner-column.vue'
import { chartColors } from '../../../../../../../shared/utils/chart-colors.js'
export default {
	components: {
		SiteScannerColumn,
		DoughnutChartCard
	},
	props: {
		scanGuid: String
	},
	data () {
		return {
			loaded: false,
			scanReport: null,
			chartOptions: {
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					legend: {
						display: false
					},
					title: {
						display: false
					}
				}
			},
			chartDatas: [],
			scanCharts: []
		}
	},
	computed: {
		plugins () {
			return [{
				title: {
					display: true,
					text: 'Custom Chart Title'
				}
			}]
		}
	},
	async created () {
		const { data } = await getScanSummary(this.scanGuid)
		this.scanReport = data
		this.$emit('set-scan-name', this.scanReport.currentScan.summary.scanName)
		this.$emit('set-gpc-detected', this.scanReport.currentScan.summary.gpcDetected)
		if (this.scanReport.previousScan) {
			this.$emit('set-scan-caption', {
				currentScanId: this.scanReport.currentScan.summary.scanId,
				previousScanId: this.scanReport.previousScan.summary.scanId
			})
		}
		for (let i = 0; i < 3; i++) {
			const { data } = await getScanChart(this.scanGuid, i + 1)
			this.chartDatas[i] = this.chartData(data)
		}
		this.loaded = true
	},
	methods: {
		chartData (chart) {
			const { chartItems } = chart

			const labels = []
			const datasets = [
				{
					data: [],
					backgroundColor: chartItems.map((item, index) => {
						return chartColors[index]
					})
				}
			]
			chartItems.forEach(({ categoryName, count }) => {
				if (count === 0) {
					return
				}
				labels.push(categoryName)
				datasets[0].data.push(count)
			})
			return {
				labels,
				datasets
			}
		}
	}
}
</script>
